import createHash from 'sha.js'
import get from 'lodash/get'
import { DocumentNode } from '@apollo/client'

export const isFile = (src?: string) => {
  return !!src ? src.indexOf('.pdf') >= 0 : false
}
export const A4_RATIO = 1.414
export const queryName = (doc: DocumentNode) =>
  get(doc, 'definitions.0.name.value')

export const VIR_SCALE_MSG = 'Note: Image not to scale.'
export const NBSP = String.fromCharCode(parseInt('A0', 16))

export const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.children
)

export function getImgURL(image: string): string {
  /*
      Combines the image path with the RAZZLE_IMAGEKIT_PATH
  
      Removes leading `/` from the image, if there is any.
    */
  if (image.indexOf('/') === 0) {
    image = image.substring(1, image.length)
  }
  return `${process.env.RAZZLE_IMAGE_BASE}${image}`
}

export function Rand(max: number = 65535) {
  return Math.floor(Math.random() * max)
}

export const sortExtId = (a: any, b: any) => a.externalId - b.externalId

export function getAllLocationItemIds(project: any) {
  /**
   * Turns all location items into a flat list.
   * This helps when we need to figure out to which location item to redirect
   * to.
   */
  const result: any[] = []
  project.locations.forEach((loc: any) => {
    loc.locationItems.forEach((locItem: any) => {
      result.push({
        locId: loc.externalId,
        locIsReady: loc.locationIsReady,
        locItemId: locItem.externalId,
        locItemIsReady: locItem.locationItemIsReady,
      })
    })
  })
  return result
}

export function getNextLocation(
  allLocationItemIds: any[],
  currentLocationId?: number
) {
  // If we are on the Overview view, it should redirect to the location view.
  if (!currentLocationId) {
    return allLocationItemIds[0]
  }

  if (!!currentLocationId) {
    let foundIndex = -1
    allLocationItemIds.forEach((item: any, index: number) => {
      if (`${item.locId}` === `${currentLocationId}`) {
        foundIndex = index
      }
    })
    if (foundIndex === -1 || foundIndex === allLocationItemIds.length - 1) {
      return null
    } else {
      return allLocationItemIds[foundIndex + 1]
    }
  }
}

export function getNextLocationItem(
  allLocationItemIds: any[],
  currentLocId: number,
  currentLocItemId: number
) {
  // Find the next LocationItem to redirect to.

  let foundIndex = -1
  let foundNotReadyIndex = -1

  allLocationItemIds.forEach((item: any, index: number) => {
    if (foundNotReadyIndex === -1 && !item.locItemIsReady) {
      foundNotReadyIndex = index
    }
    if (
      `${item.locId}` === `${currentLocId}` &&
      `${item.locItemId}` === `${currentLocItemId}`
    ) {
      foundIndex = index
    }
  })

  if (foundIndex === -1 || foundIndex === allLocationItemIds.length - 1) {
    if (foundNotReadyIndex > -1) {
      return allLocationItemIds[foundNotReadyIndex]
    }
    return null
  } else {
    return allLocationItemIds[foundIndex + 1]
  }
}

export function getStepsFromProject(project: any) {
  /**
   * Returns array of steps for given project
   */
  // Prepare variables for url generation
  const hashId = get(project, 'hashId', '')
  const locationExId = get(project, 'locations.0.externalId', '')
  const locItemExId = get(project, 'locations.0.locationItems.0.externalId', '')
  const items = []
  items.push({
    title: 'Project Title',
    url: `/en/u/project/${hashId}/title/`,
  })
  items.push({
    title: 'Project Type',
    url: `/en/u/project/${hashId}/type/`,
  })
  items.push({
    title: 'Project Deadline',
    url: `/en/u/project/${hashId}/timeline/`,
  })
  items.push({
    title: 'Project Budget',
    url: `/en/u/project/${hashId}/budget/`,
  })
  items.push({
    title: 'Project Areas',
    url: `/en/u/project/${hashId}/areas/`,
  })
  items.push({
    title: 'Summary',
    url: `/en/u/project/${hashId}/summary/`,
  })

  return items
}

export const sha256 = (data: string | ArrayBuffer | null | undefined) => {
  let hash = createHash('sha256')
  let result = ''
  if (typeof data === 'string') {
    hash = hash.update(data, 'utf8')
    result = hash.digest('hex')
  } else if (data instanceof ArrayBuffer) {
    hash = hash.update(new DataView(data))
    result = hash.digest('hex')
  }
  return result
}

export const isHideVir = (product: any) => {
  return (
    product?.hideVir ||
    product?.site !== 'artling' ||
    ['design', 'book'].indexOf(get(product, 'category.slug', '')) >= 0 ||
    ['new-media', 'sculpture'].indexOf(get(product, 'medium.slug', '')) >= 0
  )
}

export const isHideVos = (product: any) => {
  return product?.site !== 'artling' && product?.site !== 'artshare'
}

export const createMarkup = (content: string) => {
  return { __html: content }
}

export const productValidForDiscount = (
  site?: string,
  galleryName?: string,
  categorySlug?: string
) => {
  // check if product is valid for discount
  // requirements:
  // from artling
  // not from a gallery
  // only for artwork
  if (
    site !== 'artling' ||
    galleryName ||
    !['artwork'].includes(categorySlug || '')
  ) {
    return false
  }
  return true
}

export function precisionRoundMod(number: number, precision: number) {
  var factor = Math.pow(10, precision)
  var n = precision < 0 ? number : 0.01 / factor + number
  return Math.round(n * factor) / factor
}
